module.exports = __webpack_public_path__ + "static/media/pink_card_bg.41904d96.png";